import React, { Component } from "react"
import NotificationItem from "./NotificationITem"
import Counter from "../Counter"
import { NotificationIcon } from "../../normalizer"

export default class NotificationList extends Component {
  handleClick = e => {
    const isContainer = !!this.node.contains(e.target)
    if (!isContainer && this.props.opened) {
      this.props.onListHide()
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick, false)
  }

  render() {
    const {
      notifications,
      opened,
      numNotificationsToShow,
      onListShow,
      onListHide,
      onNotificationView,
      onHandleScroll
    } = this.props

    const hasNotifications = numNotificationsToShow > 0

    return (
      <div
        className="gl-notification__container gl-above-content campaign-link-icon"
        ref={node => (this.node = node)}
      >
        <div id="notification-bell" onClick={opened ? onListHide : onListShow}>
          <NotificationIcon className="gl-navbar__icons24 mb-3 cursor-pointer campaign-link-icon__stroke" />
          {hasNotifications && <Counter value={numNotificationsToShow} />}
        </div>
        {opened && (
          <div
            className="gl-notification__dropdown default-bg  primary-text  gl-round gl-content-shadow"
            id="notification-dropdown"
          >
            <div className="gl-notification__dropdown__scrolling" id="notification-dropdown" onScroll = { onHandleScroll } >
              {
                notifications.map(n => (
                  <NotificationItem 
                    onNotificationView={onNotificationView} 
                    key={n.id} 
                    {...n}
                  />
                ))
              }
              {!hasNotifications &&  notifications.length === 0 && (
                <div className="flex flex-col items-center ">
                  <i className="primary-text fas fa-bell-slash text-xl mb-2"></i>
                  <p className="text-size">Sem notificações</p>
                </div>
              )}
            </div>
          </div> 
        )}
      </div>
    )
  }
}
